export const endingParagraphs = [
  '系列的结局并没有安排一场大快人心的“翻盘”。相反，它选择把镜头拉远：热闹散场，长桌上只剩下冷掉的杯盘，每个人各自回到自己的生活里，继续面对当初想逃开的那些问题。',
  '从叙事结构上看，结局更像是一次“结算”。前面铺开的每一段越界、每一次算计、每一个被忽略的细节，都在后段被逐一兑现。谁也没有全身而退——但作品也没有急着把谁钉在道德的柱子上，它只是安静地展示结果。',
  '值得注意的是，结局始终没有给出一个明确的“正确选择”。它把判断权留给观众：有人会同情那个守着家的人，有人会理解想要逃离的人，也有人会记住沉默者眼里那点清醒。这种留白，正是它区别于普通爽剧的地方。',
];

export const endingReadings = [
  {
    icon: 'ri-emotion-sad-line',
    title: '解读一：倦怠才是真正的主角',
    desc: '把这些越界全部拿掉，剩下的其实是“日子过不下去了”。作品真正想谈的，是婚姻里那种缓慢、无声的疏远。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '解读二：信任被当成工具',
    desc: '第二部之后，感情成了引流的幌子，金钱才是目标。结局把这种“熟人算计”的荒诞感推到最满。',
  },
  {
    icon: 'ri-eye-line',
    title: '解读三：旁观者最清醒',
    desc: '那个话最少的角色贯穿始终，像一条若隐若现的旁白。结局的回响，很大程度上由他的沉默来完成。',
  },
];

export const endingTakeaway = {
  title: '一句话总结结局',
  text: '没有人赢，也没有人被彻底审判。《出轨同学会》的结局是一次安静的结算——它不告诉你谁对谁错，只让你看清每个人为自己的选择付出了什么。',
};